import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import {
  ProgressionModel,
  ProgressionModelServer,
} from 'features/wildfires/wildfire.types';
import { parseProgressionModelServer } from 'features/wildfires/utils/parseProgressionModelServer';
import { useProgressionModelsEnabled } from '../useProgressionModelsEnabled';

type UseProgressionModelsProps = {
  wildfireId?: number;
};

type UseProgressionModels = Omit<
  UseQueryResult<ProgressionModel[], Error>,
  'data'
> & {
  progressionModels: ProgressionModel[];
};

const fetchProgressionModels = async (
  geoEventId: number,
): Promise<ProgressionModelServer[]> => {
  const response = await API.get<ProgressionModelServer[]>(
    'fire_progression_models/runs/',
    {
      params: { geo_event_id: geoEventId },
    },
  );
  return response.data;
};

export const useProgressionModels = (
  props: UseProgressionModelsProps,
): UseProgressionModels => {
  const { wildfireId } = props;
  const showProgressionModels = useProgressionModelsEnabled();

  const { data = [], ...results } = useQuery({
    queryKey: ['progressionModels', wildfireId],
    queryFn: () => fetchProgressionModels(wildfireId!),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: Boolean(wildfireId) && showProgressionModels,
    select: (models) => models.map(parseProgressionModelServer),
  });

  return { ...results, progressionModels: data };
};
